// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"sZ-z","subtitle":"tZ-z","wrapper":"uZ-z","leftArrow":"vZ-z","rightArrow":"wZ-z"};